var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(_vm.component, { tag: "component" }, [
    _vm._v(_vm._s(_vm.converted)),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }